module.exports = __webpack_public_path__ + "static/Theo_new-8434f33241a6fa8af089f33452657736.svg";